"use strict";
var ulElement = document.querySelector("ul");
// const listItem = document.querySelectorAll('ul li');
function parseSalary(salaryString) {
    return Number(salaryString.replace(/[$,]/g, ""));
}
function sortList(list) {
    var itemsArray = Array.from(list.children);
    itemsArray.sort(function(a, b) {
        var salaryA = parseSalary(a.dataset.salary);
        var salaryB = parseSalary(b.dataset.salary);
        return salaryB - salaryA;
    });
    itemsArray.forEach(function(item) {
        return list.appendChild(item);
    });
}
function getEmployees(list) {
    var employeesArray = Array.from(list.children).map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
    return employeesArray;
}
sortList(ulElement);
getEmployees(ulElement);
// eslint-disable-next-line no-console
console.log(getEmployees(ulElement));

//# sourceMappingURL=index.ed5aa4e8.js.map
